// extracted by mini-css-extract-plugin
export default {"section":"HomeSection_section__Mgc5C","visible":"HomeSection_visible__8YIYr","heading":"HomeSection_heading__f7e5c"};